import { FC } from 'react';
import { Box } from 'ui/Box';
import { Typography } from 'ui/Typography';
import { IconButton } from 'ui/IconButton';
import { EditIcon } from 'components/icons/EditIcon';
import { DeleteIcon } from 'components/icons/DeleteIcon';
import { AddedMember } from 'types/api';

export interface AddedMemberProps {
  index: number;
  roleLabel: string;
  member: AddedMember;
  onDelete: () => void;
  onEdit: (index: number) => void;
}

export const AddedMemberItem: FC<AddedMemberProps> = ({
  roleLabel,
  member,
  index,
  onEdit,
  onDelete,
}) => (
  <Box className="flex w-full justify-between rounded bg-light-gray px-3 py-2 text-black">
    <Box className="flex flex-col gap-2 text-black md:flex-row">
      <Typography
        variant="h5"
        className="rounded bg-light-gray text-black md:min-w-40"
      >
        #{index + 1}
      </Typography>
      <Box className="flex w-full flex-col">
        <Typography
          variant="h5"
          className="line-clamp-1 min-w-0 truncate text-wrap break-all"
        >
          {member.full_name}
        </Typography>
        <Typography variant="h5" className="flex-shrink-0">
          {member.email}
        </Typography>
        <Typography variant="h5" className="flex-shrink-0">
          {roleLabel}
        </Typography>
        <Typography
          variant="h5"
          className="line-clamp-1 min-w-0 truncate text-wrap break-all"
        >
          {member.position}
        </Typography>
      </Box>
    </Box>
    <Box className="ml-2 flex flex-col gap-2">
      <IconButton onClick={() => onEdit(index)}>
        <EditIcon className="h-6 w-6 rounded bg-light-gray fill-none p-1 text-blue" />
      </IconButton>
      <IconButton onClick={onDelete}>
        <DeleteIcon className="h-6 w-6 rounded bg-light-gray p-1 text-red" />
      </IconButton>
    </Box>
  </Box>
);
